import {client} from "./ApiClient";
import {mapServiceUrls} from "../Helpers/Globals";
import {useMutation, useQuery, useQueryClient} from "react-query";

const leaveGroup = ({urls, accessKey, customerUid, groupUid}) => {
    return client(mapServiceUrls(urls).LoyaltyEngineApiUrl, `api/v4/${accessKey}/subscriberGroups/commands/leaves`, {
        body: {
            // MembershipUid,
            CustomerUid: customerUid,
            SubscriberGroupUid: groupUid
        }
    })
}

export default function useLeaveGroup() {
    return useMutation(leaveGroup);
}